export const SESSION_STALE_TIME = 29 * 60 * 1000;
export const SESSION_GC_TIME = 720 * 60 * 1000;
